module.exports = __webpack_public_path__ + "static/img/theme5.6c30165f.jpg";